(function (module) {
    'use strict';

    module.directive('windowWidth', ($window) => {
        return {
            restrict: 'A',
            link: function ($scope, $element, attrs) {
                $scope.windowWidth = $window.innerWidth;
                angular.element($window).bind('resize', () => {
                    $scope.windowWidth = $window.innerWidth;
                });
            }
        };
    });

})(angular.module('rocket.components'));
